export const useBenefits = () => {
  const { t } = useI18n()
  return {
    benefits: [
      {
        title: t('aboutCompany.benefits.card1.title'),
        description: t('aboutCompany.benefits.card1.lead'),
        image: {
          src: '/images/abroad/cards/card1.jpg'
        }
      },
      {
        title: t('aboutCompany.benefits.card2.title'),
        description: t('aboutCompany.benefits.card2.lead'),
        image: {
          src: '/images/abroad/cards/card2.jpg'
        }
      },
      {
        title: t('aboutCompany.benefits.card3.title'),
        description: t('aboutCompany.benefits.card3.lead'),
        image: {
          src: '/images/abroad/cards/card3.jpg'
        }
      },
      {
        title: t('aboutCompany.benefits.card4.title'),
        description: t('aboutCompany.benefits.card4.lead'),
        image: {
          src: '/images/abroad/cards/card4.jpg'
        }
      }
    ]
  }
}